import React, { useState, useEffect } from "react";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
//import "./printOut/assets/billModal.css";
import { getLoginInfo } from '../../../shared/utils/storage';
import AssessmentTable from "../../../shared/components/AssessmentTable";
import ApplicationsTableComponent from "../../../shared/components/ApplicationsTable";
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import Lindo from '../../../app/guards/RouteGuard';

const Assessment = () => {
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [applications, setApplications] = useState([]);
  const [appStatistics, setAppStatistics] = useState({});
  const [isPulled, setIsPulled] = useState(false);
  const { mgambo } = Lindo();
  useEffect(() => {
    viewApplications();
  }, []);

  const viewApplications = async () => {
    mgambo("Uchambuzi");
    const payload = {
      ApplicationId: "",
      UserName: getLoginInfo()?.user?.Username,
      StageId: 510,
      Station: getLoginInfo()?.user?.StationID,
      Action: "Pool",
      AccessorId: getLoginInfo()?.user?.UserID,
    };
    const result = await handleApplicationManagement(
      payload,
      "application_management",
    );
    if (result?.code == 1) {
      setApplications(result?.data?.Applications);
      setAppStatistics(result?.data?.StatisticsApp[0]);
    } else {
      // console.log(result)
      setApplications(null);
      setAppStatistics({});
      // const info = { type: "error", message: result.message };
      //   createNotification(info)();
    }
  };

  const handleUpdateApplicationTable = () => {
    viewApplications();
  };
  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Assessment</i>
                </h2>
              </div>
              <AssessmentTable
                updateApplicationTable={handleUpdateApplicationTable}
                appStatistics={appStatistics}
              />
              <ApplicationsTableComponent
                applicationsData={applications}
                updateApplicationTable={handleUpdateApplicationTable}
              />
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default Assessment;
